import './editorial.css';

/**
 * EngravingImage — renders a static image with an engraving / ordered-halftone
 * treatment: desaturated + posterized to a duotone ink-on-paper ramp (SVG
 * filter #bi-engrave) with a fine ink halftone-dot overlay. Ink = --color-atomic,
 * paper endpoints are the newsprint token values (SVG filters can't read CSS
 * custom properties, so the ramp endpoints are the token *values*).
 *
 * Mount <EngraveFilterDefs/> once near the app root so `url(#bi-engrave)` resolves.
 * Applied to Brief-tab imagery only (no opt-out on that tab); do not use elsewhere yet.
 */
export function EngraveFilterDefs() {
  return (
    <svg aria-hidden="true" focusable="false" width="0" height="0"
      style={{ position: 'absolute', width: 0, height: 0, overflow: 'hidden' }}>
      <defs>
        <filter id="bi-engrave" colorInterpolationFilters="sRGB">
          <feColorMatrix type="saturate" values="0" />
          {/* Posterized duotone: luminance -> ink (#0D0D0D) ... paper (#F4EFE4) */}
          <feComponentTransfer>
            <feFuncR type="table" tableValues="0.051 0.20 0.45 0.72 0.957" />
            <feFuncG type="table" tableValues="0.051 0.19 0.43 0.70 0.937" />
            <feFuncB type="table" tableValues="0.051 0.17 0.40 0.66 0.894" />
          </feComponentTransfer>
        </filter>
      </defs>
    </svg>
  );
}

export default function EngravingImage({ src, alt = '', className = '', style, ...rest }) {
  if (!src) return null;
  return (
    <span className={`bi-engrave ${className}`.trim()} style={style}>
      <img src={src} alt={alt} {...rest} />
    </span>
  );
}
